import { render, staticRenderFns } from "./ShiftVdpIngredientsForm.vue?vue&type=template&id=7be6ee32&"
import script from "./ShiftVdpIngredientsForm.vue?vue&type=script&lang=ts&"
export * from "./ShiftVdpIngredientsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports